// extracted by mini-css-extract-plugin
module.exports = {"templates":"GenerateThumbnail_templates__2tpjX","canvas":"GenerateThumbnail_canvas__1rn9G","new":"GenerateThumbnail_new__SD0Ly","btn":"GenerateThumbnail_btn__1cRDp"};